import { RequestService } from "../../../../common/services/RequestService";
import { GET_LANDING_LIST } from "./constants";

export const getLandingListRequest = async (orderId, pagination, sort) => {
  let obj = {};
  if (sort && sort.order) {
    obj[`sort[${sort.columnKey}]`] =
      (sort.order === "ascend" && "asc") ||
      (sort.order === "descend" && "desc");
  }
  if (pagination) {
    obj["perPage"] = pagination.pageSize;
    obj["page"] = pagination.current;
  }

  let query = new URLSearchParams(obj);

  const response = await RequestService.get(
    GET_LANDING_LIST.replace("{order_id}", orderId) + (query.toString()
      ? "?" + query.toString()
      : "")
  );
  return response;
};
